import request from "./request";
import { getCookie } from "@Common";

export * from "./shopResource";
export * from "./toolGuide";
export * from "./common";
export * from "./goart/digitalCollection";
export * from "./goart/account";
export * from "./goart/common";
export * from "./account";
export * from "./facewow/account";

//获取用户折扣等级
export const getUserDiscountLevel = (uid_type: string, uid: string, platform: string, level: string) => {

    let token = uid || getCookie('credential')
    return request({
        url: "/api/activity/subscribe-user",
        method: "get",
        //类型不是 token 时，不用传 token
        headers: uid_type === 'token' ? {
            Authorization: 'bearer ' + token
        } : {},
        params: {
            uid: uid,
            platform,
            level,
        }
    });
}

export const verifUser = (code: string) => {
    return request({
        url: "/remove-risk",
        method: "get",
        baseURL: process.env.FOTOR_NEW_BASE_URL,
        params: {
            token: code,
        }
    });
}